import { safeJson } from "src/app/helpers/Index";
import React from "react";
import { ClubContext } from "src/app/helpers/ClubContext";
import { Col, Row } from "react-bootstrap";
import { Goal, Player, Substitute } from "src/app/interfaces/Index";
import { GoalService, PlayerService } from "src/app/services/Index";
import { SubstituteService } from "src/app/services/SubstituteService";
import "./ScoreboardSubstitute.css";

type Props = {};
type State = {
	sub: Substitute;
};
export class ScoreboardSubstitute extends React.Component<Props, State> {

	constructor(props: Props) {
		super(props);
		this.state = { sub: new Substitute };
	}

	componentDidMount() {
		this.getSub();
	}

	render() {
		return (
			<div id="scoreboard-wrapper2" style={{ textAlign: "center", width: 576, height: 432 }}>
				<Row>
					<h1 className="sub-heading">{this.renderHeading()}</h1>
				</Row>
				<Row style={{ height: "79%" }}>
					<Col style={{ position: "relative" }}>
						<h2 style={{ backgroundColor: "#B22222", borderTopRightRadius: 20, borderBottomRightRadius: 20 }}>OFF - {this.state.sub.playerOff?.playerNumber}</h2>
						<img src={this.state.sub.playerOff?.mugshotUrl} width={this.state.sub.playerOff?.teamId === ClubContext.homeTeamId ? 225 : 131} style={{ position: "absolute", bottom: 20, left: 20 }} />
					</Col>
					<Col style={{ position: "relative" }}>
						<h2 style={{ backgroundColor: "limegreen", borderTopLeftRadius: 20, borderBottomLeftRadius: 20 }}>ON - {this.state.sub.playerOn?.playerNumber}</h2>
						<img src={this.state.sub.playerOn?.mugshotUrl} width={this.state.sub.playerOff?.teamId === ClubContext.homeTeamId ? 225 : 131} style={{ position: "absolute", bottom: 20, right: 20 }} />
					</Col>
				</Row>
				<Row style={{ width: 576, height: 50, backgroundColor: "#293246", position: "absolute", left: 12, bottom: 0 }}>
					<Col className="sponsor-heading">SPONSORED BY</Col>
					<Col><img src={"https://sufc.blob.core.windows.net/uploads/JS_AGroup_Shorter.jpg"} height="50" /></Col>
				</Row>

			</div>
		);
	}

	async getSub() {
		const res = await safeJson(SubstituteService.getLatest());
		if (res && res.error) {
		}

		if (res) this.setState({ sub: res });
	}

	renderHeading() {
		if (this.state.sub.playerOff?.teamId === ClubContext.homeTeamId) return "IRON - SUBSTITUTION"
		else return "VISITOR - SUBSTITUTION"

	}
}